var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarLayout',{attrs:{"classname":'section-np project-page'}},[_c('ProjectTopMenu',{attrs:{"project":_vm.project}}),_c('IncomingTenderAlertBlock'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }